(function () {
  'use strict';
  function mount(root) {
    root.querySelectorAll('[data-asos-trust-carousel]').forEach(function (section) {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const track = section.querySelector('.trust_inner');
      const items = Array.from(track.children);
      const pageCount = Math.ceil(items.length / 2);
      if (pageCount < 2) return;
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let timer, page = 0, visible = false, dragging = false, focused = false;
      function clear() { clearTimeout(timer); }
      function schedule() {
        clear();
        if (!section.isConnected || !mobile.matches || reduced.matches || dragging || focused || !visible || document.hidden) return;
        timer = setTimeout(function () { show((page + 1) % pageCount); }, 4000);
      }
      function show(index, instant) {
        page = index;
        const item = items[index * 2];
        track.scrollTo({ left: item.offsetLeft - items[0].offsetLeft, behavior: instant || reduced.matches ? 'instant' : 'smooth' });
        schedule();
      }
      track.addEventListener('pointerdown', function () { dragging = true; clear(); }, { passive: true });
      function release() { if (!dragging) return; dragging = false; schedule(); }
      track.addEventListener('pointerup', release, { passive: true });
      track.addEventListener('pointercancel', release, { passive: true });
      track.addEventListener('pointerleave', release, { passive: true });
      track.addEventListener('scroll', function () {
        const next = Math.max(0, Math.min(pageCount - 1, Math.round(track.scrollLeft / track.clientWidth)));
        if (next !== page) page = next;
      }, { passive: true });
      section.addEventListener('focusin', function () { focused = true; clear(); });
      section.addEventListener('focusout', function (event) { if (!section.contains(event.relatedTarget)) { focused = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      mobile.addEventListener('change', function () { show(0, true); });
      reduced.addEventListener('change', schedule);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          if (!section.isConnected) { clear(); observer.disconnect(); return; }
          visible = entries[0].isIntersecting; schedule();
        }, { threshold: 0.5 });
        observer.observe(section);
      } else { visible = true; schedule(); }
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
})();